import {api} from '../../helpers/Api'

export class Request {
  
  static getAfiliate = (publictoken, at) => {
    return api(publictoken).get(`/afiliatestoken/${at}`)
  }
}
